<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">C<span class="small">ONTENTS</span></p>
<p class="toc"><a href="#/preface">Preface</a></p>
<p class="toc"><a href="#/acknowledgements">Acknowledgements</a></p>
<p class="toc"><a href="#/introduction">Introduction: The End</a></p>
<p class="toc1"><a href="#/chapter01">Chapter 1. The Beginning</a></p>
<p class="toc"><span href="#/chapter02" title="Link target outside of Sample">Chapter 2. Testing the Faith</span></p>
<p class="toc"><span href="#/chapter03" title="Link target outside of Sample">Chapter 3. The Great Awakening</span></p>
<p class="toc"><span href="#/chapter04" title="Link target outside of Sample">Chapter 4. Home and Family</span></p>
<p class="toc"><span href="#/chapter05" title="Link target outside of Sample">Chapter 5. Semptsress and Teacher</span></p>
<p class="toc"><span href="#/chapter06" title="Link target outside of Sample">Chapter 6. A Fall from Grace</span></p>
<p class="toc"><span href="#/chapter07" title="Link target outside of Sample">Chapter 7. South Hampton Summer</span></p>
<p class="toc"><span href="#/chapter08" title="Link target outside of Sample">Chapter 8. Portsmouth: Summer of 1768</span></p>
<p class="toc"><span href="#/chapter09" title="Link target outside of Sample">Chapter 9. Politics and Penal Codes</span></p>
<p class="toc"><span href="#/chapter10" title="Link target outside of Sample">Chapter 10. <i>King v. Blay</i></span></p>
<p class="toc"><span href="#/chapter11" title="Link target outside of Sample">Chapter 11. Hope and Despair</span></p>
<p class="toc"><span href="#/chapter12" title="Link target outside of Sample">Chapter 12. The Clough Connection</span></p>
<p class="toc1"><span href="#/epilogue" title="Link target outside of Sample">Epilogue</span></p>
<p class="toc"><span href="#/bm" title="Link target outside of Sample">Ruth’s Story as Retold Through Time</span></p>
<p class="toc"><span href="#/notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/abouttheauthor" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?0821bdc4